import { createStyles } from "antd-style";
import { useBreakpoint } from "@/base/utils/index";

const useStyles = createStyles(({ css }: any) => ({
  buttonCounter: css`
    display: flex;
    align-items: center;
  `,
  buttonCounterValue: css`
    pointer-events: none;
    min-width: 40px;
  `,
}));

export const useButtonCounterStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
